import Icon from '../components/Icon.vue'

Icon.register({"minus-circle":{"width":512,"height":512,"paths":[{"d":"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM124 296C117.4 296 112 290.6 112 284V228C112 221.4 117.4 216 124 216H388C394.6 216 400 221.4 400 228V284C400 290.6 394.6 296 388 296H124z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/minus-circle.js
// module id = null
// module chunks = 